import { MessageBar, MessageBarType, Stack } from "@fluentui/react";
import { styles } from "../ExperimentDetailsForm/experimentDetailsForm.styles";

interface FormSectionErrorProps {
  errors: Record<string, string[]>;
  extensionFieldErrors: string[];
}

const FormSectionError: React.FC<FormSectionErrorProps> = ({
  errors,
  extensionFieldErrors,
}) => {
  const fieldErrors = extensionFieldErrors
    .map((field) => errors[field])
    .flat()
    .filter(Boolean);
  const errorCount = fieldErrors.length;

  if (errorCount > 0) {
    return (
      <MessageBar messageBarType={MessageBarType.error}>
        <Stack
          horizontal
          verticalAlign="start"
          className={styles.experimentDetailsFormSectionError}
        >
          {`${errorCount} Error${errorCount === 1 ? "" : "s"} present`}
        </Stack>
        <ul>
          {fieldErrors.map((error) => {
            return (
              <li
                key={error}
                className={styles.experimentDetailsFormSectionErrorListItem}
              >
                {error}{" "}
              </li>
            );
          })}
        </ul>
      </MessageBar>
    );
  }
  return null;
};

export default FormSectionError;
